<template>
  <ul
    ref="track"
    class="mx-[calc(var(--raw-panel-space)*-1)] flex select-none gap-12 overflow-x-auto overscroll-x-contain px-[--raw-panel-space]"
    :data-dragging="dragging ? '' : undefined"
  >
    <slot />
  </ul>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import { useDraggableRail } from '~/scopes/campaign/composables/useDraggableRail'

// Horizontal free-scroll/drag rail for panel content. Pulling out by
// `--raw-panel-space` and padding back in by the same amount bleeds it to the host's
// glass edge, whatever that host pads, so the last item peeks past the edge as a
// "there's more" hint. Slot in the `<li>` items.
const track = ref<HTMLUListElement | null>(null)
const { dragging } = useDraggableRail(track)
</script>

<style scoped>
ul {
  scrollbar-width: none;
  cursor: grab;
}

ul[data-dragging] {
  cursor: grabbing;
}

/* A slotted full-item overlay button sits above the rail, so let it show the
   rail's grab/grabbing cursor rather than its own. */
ul :deep(button) {
  cursor: inherit;
}

/* Stop the browser's native image ghost-drag from hijacking a rail drag. */
ul :deep(img) {
  -webkit-user-drag: none;
}
</style>
